import { render, staticRenderFns } from "./ValidationErrorList.vue?vue&type=template&id=4f8d93fc&scoped=true"
import script from "./ValidationErrorList.ts?vue&type=script&lang=ts&external"
export * from "./ValidationErrorList.ts?vue&type=script&lang=ts&external"
import style0 from "./ValidationErrorList.vue?vue&type=style&index=0&id=4f8d93fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8d93fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f8d93fc')) {
      api.createRecord('4f8d93fc', component.options)
    } else {
      api.reload('4f8d93fc', component.options)
    }
    module.hot.accept("./ValidationErrorList.vue?vue&type=template&id=4f8d93fc&scoped=true", function () {
      api.rerender('4f8d93fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Uploader/components/ValidationErrorList/ValidationErrorList.vue"
export default component.exports